import clsx from 'clsx'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React, { Fragment } from 'react'
import { Accordion, AccordionItem } from '../components/accordian'

const FaqContent = () => {
  const {
    allFile: { nodes },
  } = useStaticQuery(graphql`
    {
      allFile(filter: { base: { eq: "faq.json" } }) {
        nodes {
          childJson {
            faq {
              sections {
                title
                items {
                  title
                  images {
                    imageSrc {
                      childrenImageSharp {
                        gatsbyImageData
                      }
                      publicURL
                    }
                    alt
                    width
                    height
                  }
                  sections {
                    title
                    text
                    textArray
                  }
                  text
                }
              }
            }
          }
        }
      }
    }
  `)
  const faqData = nodes[0].childJson.faq
  return (
    <section>
      {faqData.sections.map((section, sectionIndex) => (
        <div className="mb-12" key={sectionIndex}>
          <h3 className="mb-4 text-lg font-bold lg:font-medium lg:mb-8 lg:text-2xl">
            {section.title}
          </h3>
          <Accordion>
            {section.items.map((item, index) => (
              <AccordionItem label={item.title} index={index} key={index}>
                <div
                  className={clsx({
                    'flex xl:flex-row flex-col-reverse': item.images != null,
                  })}
                >
                  {item.images != null && (
                    <div className="w-full xl:w-1/2 text-center">
                      {item.images.map((img, imgIndex) =>
                        img.imageSrc.childrenImageSharp?.[0] ? (
                          <GatsbyImage
                            key={imgIndex}
                            image={
                              img.imageSrc.childrenImageSharp[0].gatsbyImageData
                            }
                            alt={img.alt}
                            className="max-w-md mb-4 rounded-lg"
                          />
                        ) : (
                          <img
                            key={imgIndex}
                            src={img.imageSrc.publicURL}
                            alt={img.alt}
                            width={img.width}
                            height={img.height}
                            className="mx-auto mb-4 rounded-lg"
                          />
                        )
                      )}
                    </div>
                  )}
                  {item.sections != null && (
                    <div
                      className={clsx('xl:pl-4 section-text', {
                        'xl:w-1/2': item.images != null,
                      })}
                    >
                      {item.sections.map((itemSection, itemSectionIndex) => (
                        <Fragment key={itemSectionIndex}>
                          {itemSection.title && (
                            <p className="mb-2 font-bold text-black ">
                              {itemSection.title}
                            </p>
                          )}
                          <div
                            className="mb-4 text-grey"
                            dangerouslySetInnerHTML={{
                              __html: getText(itemSection),
                            }}
                          ></div>
                        </Fragment>
                      ))}
                    </div>
                  )}
                  {item.text != null && <p className="mb-2">{item.text}</p>}
                </div>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      ))}
    </section>
  )
}
export default FaqContent

function getText(itemSection) {
  if (itemSection.text != null) {
    return itemSection.text
  }
  if (itemSection.textArray != null) {
    return itemSection.textArray.join('')
  }
  return ''
}
